import { render, staticRenderFns } from "./GlobalOfferDataTable.vue?vue&type=template&id=bea46ab0&scoped=true&lang=html&"
import script from "./GlobalOfferDataTable.vue?vue&type=script&lang=js&"
export * from "./GlobalOfferDataTable.vue?vue&type=script&lang=js&"
import style0 from "./GlobalOfferDataTable.vue?vue&type=style&index=0&id=bea46ab0&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea46ab0",
  null
  
)

export default component.exports